import React, { useEffect, useRef } from "react";

// SASS
import "./Part4.scss";

// COMPONENTS
import Step from "../Step/Step";

// HELPERS
import animate from "../../utils/animate";

// LIBRARIES
import scrollama from "scrollama";

// ASSETS
import educatorImg from "../../assets/img/Educator.png";
import whiteboardImg from "../../assets/img/Whiteboard.png";
import audienceImg from "../../assets/img/Audience.png";
import thoughtBubbleImg from "../../assets/img/Thought-Bubble-White-Inside2.png";
import thoughtBubbleSneeze1Img from "../../assets/img/Thought-Bubble-Sneeze-1.png";
import thoughtBubbleSneeze2Img from "../../assets/img/Thought-Bubble-Sneeze-2_Shot1.png";
import thoughtBubbleSneeze3Img from "../../assets/img/Thought-Bubble-Sneeze-2_Shot2.png";
import splashImg from "../../assets/img/Icon_Splash.svg";
import coughImg from "../../assets/img/Icon_Respiratory-Droplets.svg";
import eyeImg from "../../assets/img/Icon_Eye.svg";

export default function Part4({ step }) {
  // SCROLLAMA INSTANCE
  const scrolly = scrollama();

  // ANIMATION STEP DATA
  const animationSequence = [
    { stepNumber: "0", height: null, description: "spacer" },
    {
      stepNumber: "1",
      height: null,
      description: "hide hide--1, show reveal--1",
    },
    { stepNumber: "2", height: null, description: "show reveal--2a, 2b, 2c" },
    { stepNumber: "3", height: null, description: "show reveal--3a, 3b, 3c" },
    {
      stepNumber: "4",
      height: null,
      description: "add class show to animate--3a, animate--3b",
    },
    {
      stepNumber: "5",
      height: null,
      description: "hide hide--2, hide animate 3-b",
    },
    { stepNumber: "6", height: null, description: "spacer" },
    { stepNumber: "7", height: null, description: "spacer" },
    { stepNumber: "8", height: null, description: "spacer" },
    { stepNumber: "9", height: null, description: "spacer" },
  ];

  // REFS
  const hide1Ref = useRef(null);
  const reveal1Ref = useRef(null);
  const reveal2aRef = useRef(null);
  const reveal2bRef = useRef(null);
  const reveal2cRef = useRef(null);
  const reveal3aRef = useRef(null);
  const reveal3bRef = useRef(null);
  const reveal3cRef = useRef(null);
  const animate4aRef = useRef(null);
  const animate4bRef = useRef(null);
  const hide2Ref = useRef(null);
  const reveal5Ref = useRef(null);
  const reveal6Ref = useRef(null);
  const reveal7Ref = useRef(null);
  const reveal8Ref = useRef(null);

  // RUN WHEN THE COMPONENT MOUNTS
  useEffect(() => {
    scrolly
      .setup({
        step: `.${step}`,
        debug: false,
        threshold: 1,
        progress: true,
      })
      .onStepEnter(({ element, direction }) => {
        const step = element.dataset.step;
        switch (step) {
          case "1": {
            animate.fadeOutOnEnter(hide1Ref.current, direction);
            animate.fadeInOnEnter(reveal1Ref.current, direction);
            break;
          }
          case "2": {
            animate.fadeInOnEnter(reveal2aRef.current, direction);
            animate.fadeInOnEnter(reveal2bRef.current, direction);
            animate.fadeInOnEnter(reveal2cRef.current, direction);
            break;
          }
          case "3": {
            animate.fadeInOnEnter(reveal3aRef.current, direction);
            animate.fadeInOnEnter(reveal3bRef.current, direction);
            animate.fadeInOnEnter(reveal3cRef.current, direction);
            break;
          }
          case "4": {
            animate.addClassOnEnter(animate4aRef.current, "show", direction);
            animate.addClassOnEnter(animate4bRef.current, "show", direction);
            break;
          }
          case "5": {
            animate.fadeOutOnEnter(hide2Ref.current, direction);
            animate.fadeOutOnEnter(animate4bRef.current, direction);
            animate.addClassOnEnter(animate4aRef.current, "grow", direction);
            animate.fadeInOnEnter(reveal5Ref.current, direction);
            break;
          }
          case "6": {
            animate.fadeInOnEnter(reveal6Ref.current, direction);
            break;
          }
          case "7": {
            animate.fadeInOnEnter(reveal7Ref.current, direction);
            break;
          }
          case "8": {
            animate.fadeInOnEnter(reveal8Ref.current, direction);
            break;
          }
          default:
            break;
        }
      })
      .onStepProgress(({ element, progress }) => {
        const step = element.dataset.step;
        switch (step) {
          default:
            break;
        }
      })
      .onStepExit(({ element, direction }) => {
        const step = element.dataset.step;
        switch (step) {
          case "1": {
            animate.fadeInOnExit(hide1Ref.current, direction);
            animate.fadeOutOnExit(reveal1Ref.current, direction);
            break;
          }
          case "2": {
            animate.fadeOutOnExit(reveal2aRef.current, direction);
            animate.fadeOutOnExit(reveal2bRef.current, direction);
            animate.fadeOutOnExit(reveal2cRef.current, direction);
            break;
          }
          case "3": {
            animate.fadeOutOnExit(reveal3aRef.current, direction);
            animate.fadeOutOnExit(reveal3bRef.current, direction);
            animate.fadeOutOnExit(reveal3cRef.current, direction);
            break;
          }
          case "4": {
            animate.removeClassOnExit(animate4aRef.current, "show", direction);
            animate.removeClassOnExit(animate4bRef.current, "show", direction);
            break;
          }
          case "5": {
            animate.fadeInOnExit(hide2Ref.current, direction);
            animate.fadeInOnExit(animate4bRef.current, direction);
            animate.removeClassOnExit(animate4aRef.current, "grow", direction);
            animate.fadeOutOnExit(reveal5Ref.current, direction);
            break;
          }
          case "6": {
            animate.fadeOutOnExit(reveal6Ref.current, direction);
            break;
          }
          case "7": {
            animate.fadeOutOnExit(reveal7Ref.current, direction);
            break;
          }
          case "8": {
            animate.fadeOutOnExit(reveal8Ref.current, direction);
            break;
          }
          default:
            break;
        }
      });
  }, [scrolly, step]);

  // CUSTOM FUNCTIONS

  return (
    <section className="wrapper">
      <div className="sticky-container">
        {/* STICKY */}
        <div className="part4">
          <div className="presentation hide hide--2" ref={hide2Ref}>
            <div className="presentation__whiteboard-wrapper">
              <div className="presentation__whiteboard">
                <img src={whiteboardImg} alt="" className="img-fluid" />
                <div className="presentation__speaker">
                  <img src={educatorImg} alt="" className="img-fluid" />
                </div>
                <div className="presentation__text-container">
                  {/* INSERT CONTENT HERE */}
                  <div className="screen screen--1 hide hide--1" ref={hide1Ref}>
                    With eye protection, <br /> we protect ourselves from…
                  </div>
                  <div
                    className="screen screen--2 reveal reveal--1"
                    ref={reveal1Ref}
                  >
                    <div className="text text--1">
                      Splashes <br />& Sprays
                    </div>
                    <div
                      className="text text--2 reveal reveal--2a"
                      ref={reveal2aRef}
                    >
                      Respiratory <br />
                      droplets
                    </div>
                    <div
                      className="text text--3 reveal reveal--3a"
                      ref={reveal3aRef}
                    >
                      Carrying germs that <br />
                      may land in the eye
                    </div>
                    <div
                      className="text text--4 reveal reveal--2b"
                      ref={reveal2bRef}
                    >
                      +
                    </div>
                    <div
                      className="text text--5 reveal reveal--3b"
                      ref={reveal3bRef}
                    >
                      =
                    </div>
                    <div className="icon icon--splash">
                      <img src={splashImg} alt="" className="img-fluid" />
                    </div>
                    <div
                      className="icon icon--cough reveal reveal--2c"
                      ref={reveal2cRef}
                    >
                      <img src={coughImg} alt="" className="img-fluid" />
                    </div>
                    <div
                      className="icon icon--eye reveal reveal--3c"
                      ref={reveal3cRef}
                    >
                      <img src={eyeImg} alt="" className="img-fluid" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="presentation__audience-wrapper">
              <div className="presentation__audience">
                <img src={audienceImg} alt="" className="img-fluid" />
              </div>
            </div>
          </div>
          <div className="thoughts">
            <div
              className="bubble-wrapper animate animate--4a"
              ref={animate4aRef}
            >
              <div className="bubble bubble--1">
                <img src={thoughtBubbleImg} alt="" className="img-fluid" />
                <div className="text">Imagine</div>
              </div>
              <div
                className="bubble bubble--2 reveal reveal--5"
                ref={reveal5Ref}
              >
                <img
                  src={thoughtBubbleSneeze1Img}
                  alt=""
                  className="img-fluid"
                />
                <div className="text">
                  Someone starts coughing while talking to you...
                </div>
              </div>
              <div
                className="bubble bubble--3 reveal reveal--6"
                ref={reveal6Ref}
              >
                <img src={thoughtBubbleImg} alt="" className="img-fluid" />
                <div className="text">
                  ...if neither of you are using PPE, as they cough and talk,
                  some of their
                  <br />
                  <span className="blue">
                    respiratory droplets can travel
                  </span>{" "}
                  <br />
                  from their mouth and land on to your eyes.
                </div>
              </div>
              <div
                className="bubble bubble--4 reveal reveal--7"
                ref={reveal7Ref}
              >
                <img
                  src={thoughtBubbleSneeze2Img}
                  alt=""
                  className="img-fluid"
                />
              </div>
              <div
                className="bubble bubble--5 reveal reveal--8"
                ref={reveal8Ref}
              >
                <img
                  src={thoughtBubbleSneeze3Img}
                  alt=""
                  className="img-fluid"
                />
              </div>
            </div>
            <div
              className="bubble-trail animate animate--4b"
              ref={animate4bRef}
            >
              <div className="circle circle--1"></div>
              <div className="circle circle--2"></div>
              <div className="circle circle--3"></div>
            </div>
          </div>
        </div>
      </div>

      {/* STEPS */}
      {animationSequence.map(({ stepNumber, height, description, offset }) => {
        return (
          <Step
            stepSection={step}
            stepNumber={stepNumber}
            stepDescription={description}
            height={height}
            key={stepNumber}
            offset={offset}
          />
        );
      })}
    </section>
  );
}
